import { store } from "redux/store";

export const checkIsDraftComposition = (compositionListParam = null) => {
  const compositionList =
    compositionListParam ||
    store?.getState()?.encounterObj?.encounter?.compositionList;

  // Accepts compositionList and returns the element with title "Draft Transcript" or false if not found
  if (!compositionList?.length) return false;

  const draftComposition = compositionList?.find((item) => {
    return item?.resource?.title === "Draft Transcript";
  });

  return draftComposition || false; // Returns the matching element or false if not found
};

export const formatComposition = (composition) => {
  //Accepts a composition and extracts raw conversation in an array
  try {
    if (!composition) return [];
    const rawTranscriptStringified =
      composition?.resource?.section?.[3]?.title?.replace(
        "rawTranscript: ",
        ""
      );
    if (rawTranscriptStringified.length < 3) return [];
    const rawTranscriptObjectList = JSON.parse(rawTranscriptStringified);
    return rawTranscriptObjectList?.map((item) => {
      return item?.text;
    });
  } catch (error) {
    console.log("Error While parsing raw transcript", error.message);
    return [];
  }
};
